export const reverseObj = (obj: Record<string, string>): Record<string, string> => {
    const res: Record<string, string> = {};
    for (const key in obj) {
        if(obj.hasOwnProperty(key)) {
            res[obj[key]!] = key;
        }
    }
    return res;
}